import { createReport } from './report-helpers';
import { IssueReportOptions } from './issues/issueReport';
import { IssueReportTemplate } from './issues/issueReport.layout';
import { MonitoringFormsReportOptions } from './monitoringForms/monitoringFormsReport.options';
import { MonitoringFormsReportLayout } from './monitoringForms/monitoringFormsReport.layout';
import { ConfigurableMonitoringFormsReportOptions } from './configurableMonitoringForms/configurableMonitoringFormsReport.options';
import { ConfigurableMonitoringFormsReportLayout } from './configurableMonitoringForms/configurableMonitoringFormsReport.layout';
import { StudyNotesReportOptions } from './studyNotes/studyNotesReport.options';
import { StudyNotesReportLayout } from './studyNotes/studyNotesReport.layout';

export const generateIssueReport = (options: IssueReportOptions): Promise<Blob> => {
  return createReport(<IssueReportTemplate {...options} />);
};

export const generateMonitoringFormsReport = (options: MonitoringFormsReportOptions) => {
  return createReport(<MonitoringFormsReportLayout {...options} />);
};

export const generateConfigurableMonitoringFormsReport = (options: ConfigurableMonitoringFormsReportOptions) => {
  return createReport(<ConfigurableMonitoringFormsReportLayout {...options} />);
};

export const generateStudyNotesReport = (options: StudyNotesReportOptions) => {
  return createReport(<StudyNotesReportLayout {...options} />);
};
